<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Eternal Mision" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <b-row>
          <b-col cols="10">
            <h2 class="mb-2">Eternal Mision</h2>
          </b-col>
          <b-col cols="2">
            <div class="text-center">
              <quest-eternal-create-form :display_order="total_items" />
            </div>
          </b-col>
        </b-row>
      </section>
    </b-media>
    <b-card>
      <quest-eternal-table @getList="getList" :eternals="eternals" />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_perpage"
    />
  </div>
</template>

<script>
import service from "../service";
import QuestEternalCreateForm from "./_components/QuestEternalCreateForm.vue";
import QuestEternalTable from "./_components/QuestEternalTable.vue";
export default {
  components: {
    QuestEternalCreateForm,
    QuestEternalTable,
  },
  data() {
    return {
      current_page: 1,
      total_items: 0,
      items_perpage: 50,
      eternals: [],
      editLanguage: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_perpage,
      });
      if (response.data.type === "DATA") {
        this.eternals = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },
  },
};
</script>
